import React from 'react';
import styles from './NoDataComponent.module.css';
import noData from '../../../../assets/Imagess/noData.svg';
const NoDataComponent = ({ text = 'لا توجد بيانات' }) => {
  return (
    <div className={styles['noData-container']}>
      <img src={noData} alt="noData" />
      <h3>{text}</h3>
    </div>
  );
};

export default NoDataComponent;
